const avocadoData = [
  {
    Date: '2015-12-27',
    AveragePrice: 0.95,
    TotalVolume: 27297983.67,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-12-20',
    AveragePrice: 0.98,
    TotalVolume: 25083647.17,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-12-13',
    AveragePrice: 0.93,
    TotalVolume: 28041335.38,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-12-06',
    AveragePrice: 0.89,
    TotalVolume: 28800396.57,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-11-29',
    AveragePrice: 0.99,
    TotalVolume: 22617999.38,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-11-22',
    AveragePrice: 0.96,
    TotalVolume: 25114228.11,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-11-15',
    AveragePrice: 0.92,
    TotalVolume: 28597756.27,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-11-08',
    AveragePrice: 0.97,
    TotalVolume: 28485715.97,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-11-01',
    AveragePrice: 0.97,
    TotalVolume: 31047484.27,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-10-25',
    AveragePrice: 1.04,
    TotalVolume: 26240072.11,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-10-18',
    AveragePrice: 0.99,
    TotalVolume: 29375123.6,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-10-11',
    AveragePrice: 1,
    TotalVolume: 29216198.15,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-10-04',
    AveragePrice: 1.02,
    TotalVolume: 28243505.52,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-09-27',
    AveragePrice: 1.03,
    TotalVolume: 27753508.14,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-09-20',
    AveragePrice: 1.02,
    TotalVolume: 29569086.56,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-09-13',
    AveragePrice: 1.03,
    TotalVolume: 31245835.65,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-09-06',
    AveragePrice: 1.02,
    TotalVolume: 33526480.08,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-08-30',
    AveragePrice: 1.07,
    TotalVolume: 29761638.48,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-08-23',
    AveragePrice: 1.08,
    TotalVolume: 29699845.61,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-08-16',
    AveragePrice: 1.05,
    TotalVolume: 31936856.18,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-08-09',
    AveragePrice: 1.05,
    TotalVolume: 33254911.87,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-08-02',
    AveragePrice: 1.09,
    TotalVolume: 30358467.88,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-07-26',
    AveragePrice: 1.07,
    TotalVolume: 30652211.08,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-07-19',
    AveragePrice: 1.07,
    TotalVolume: 32324647.66,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-07-12',
    AveragePrice: 1.07,
    TotalVolume: 31660031.68,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-07-05',
    AveragePrice: 1.04,
    TotalVolume: 37943670.34,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-06-28',
    AveragePrice: 1.06,
    TotalVolume: 32408705.7,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-06-21',
    AveragePrice: 1.02,
    TotalVolume: 35734613.9,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-06-14',
    AveragePrice: 0.98,
    TotalVolume: 37026085.75,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-06-07',
    AveragePrice: 1,
    TotalVolume: 36549995.66,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-05-31',
    AveragePrice: 1.03,
    TotalVolume: 33720159.09,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-05-24',
    AveragePrice: 1.04,
    TotalVolume: 35344183.15,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-05-17',
    AveragePrice: 1.06,
    TotalVolume: 32027686.15,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-05-10',
    AveragePrice: 1.02,
    TotalVolume: 36400886.58,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-05-03',
    AveragePrice: 0.96,
    TotalVolume: 41291704.39,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-04-26',
    AveragePrice: 1.07,
    TotalVolume: 30894157.8,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-04-19',
    AveragePrice: 1.03,
    TotalVolume: 33091256.26,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-04-12',
    AveragePrice: 1.02,
    TotalVolume: 32046401.64,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-04-05',
    AveragePrice: 1.06,
    TotalVolume: 31500669.44,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-03-29',
    AveragePrice: 1.04,
    TotalVolume: 29982648.43,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-03-22',
    AveragePrice: 1.01,
    TotalVolume: 32513550.51,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-03-15',
    AveragePrice: 1.04,
    TotalVolume: 29572225.71,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-03-08',
    AveragePrice: 1.02,
    TotalVolume: 30094698.85,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-03-01',
    AveragePrice: 0.97,
    TotalVolume: 32994014.16,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-02-22',
    AveragePrice: 1.02,
    TotalVolume: 29936729.76,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-02-15',
    AveragePrice: 1.03,
    TotalVolume: 28012520.93,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-02-08',
    AveragePrice: 0.95,
    TotalVolume: 32137333.01,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-02-01',
    AveragePrice: 0.89,
    TotalVolume: 44655461.51,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-01-25',
    AveragePrice: 1.04,
    TotalVolume: 28470310.84,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-01-18',
    AveragePrice: 1.03,
    TotalVolume: 29043458.85,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-01-11',
    AveragePrice: 1.01,
    TotalVolume: 29063542.75,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-01-04',
    AveragePrice: 0.95,
    TotalVolume: 31324277.73,
    type: 'conventional',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2016-12-25',
    AveragePrice: 1,
    TotalVolume: 30287853.7,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-12-18',
    AveragePrice: 0.96,
    TotalVolume: 29583882.61,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-12-11',
    AveragePrice: 0.98,
    TotalVolume: 30093540.7,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-12-04',
    AveragePrice: 1,
    TotalVolume: 31621221.9,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-11-27',
    AveragePrice: 1.21,
    TotalVolume: 22923062.65,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-11-20',
    AveragePrice: 1.27,
    TotalVolume: 24989702.75,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-11-13',
    AveragePrice: 1.36,
    TotalVolume: 24075126.49,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-11-06',
    AveragePrice: 1.44,
    TotalVolume: 22534698.38,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-10-30',
    AveragePrice: 1.43,
    TotalVolume: 21009730.21,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-10-23',
    AveragePrice: 1.34,
    TotalVolume: 24753513.95,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-10-16',
    AveragePrice: 1.3,
    TotalVolume: 27707046.82,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-10-09',
    AveragePrice: 1.27,
    TotalVolume: 28857581.98,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-10-02',
    AveragePrice: 1.23,
    TotalVolume: 29615008.49,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-09-25',
    AveragePrice: 1.22,
    TotalVolume: 30305112.89,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-09-18',
    AveragePrice: 1.15,
    TotalVolume: 31346091.46,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-09-11',
    AveragePrice: 1.08,
    TotalVolume: 34126730.95,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-09-04',
    AveragePrice: 1.04,
    TotalVolume: 37130688.91,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-08-28',
    AveragePrice: 1.09,
    TotalVolume: 33993931.31,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-08-21',
    AveragePrice: 1.1,
    TotalVolume: 33592097.72,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-08-14',
    AveragePrice: 1.12,
    TotalVolume: 34386177.3,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-08-07',
    AveragePrice: 1.15,
    TotalVolume: 33819909.09,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-07-31',
    AveragePrice: 1.23,
    TotalVolume: 31201590.22,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-07-24',
    AveragePrice: 1.2,
    TotalVolume: 32339377.09,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-07-17',
    AveragePrice: 1.15,
    TotalVolume: 32656123.63,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-07-10',
    AveragePrice: 1.1,
    TotalVolume: 35567568.43,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-07-03',
    AveragePrice: 1.06,
    TotalVolume: 39993186.04,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-06-26',
    AveragePrice: 1.04,
    TotalVolume: 36617023.79,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-06-19',
    AveragePrice: 1.02,
    TotalVolume: 38489936.14,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-06-12',
    AveragePrice: 1.04,
    TotalVolume: 35580820,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-06-05',
    AveragePrice: 0.97,
    TotalVolume: 40231259.65,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-05-29',
    AveragePrice: 0.94,
    TotalVolume: 40019075.24,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-05-22',
    AveragePrice: 0.93,
    TotalVolume: 36958035.51,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-05-15',
    AveragePrice: 0.89,
    TotalVolume: 39914996.74,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-05-08',
    AveragePrice: 0.82,
    TotalVolume: 46324529.7,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-05-01',
    AveragePrice: 0.84,
    TotalVolume: 42867608.54,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-04-24',
    AveragePrice: 0.87,
    TotalVolume: 39607695.3,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-04-17',
    AveragePrice: 0.9,
    TotalVolume: 37467885.19,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-04-10',
    AveragePrice: 0.9,
    TotalVolume: 36584029.39,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-04-03',
    AveragePrice: 0.94,
    TotalVolume: 33668450.55,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-03-27',
    AveragePrice: 0.94,
    TotalVolume: 35930195.92,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-03-20',
    AveragePrice: 0.93,
    TotalVolume: 36335483.78,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-03-13',
    AveragePrice: 0.93,
    TotalVolume: 36374516.14,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-03-06',
    AveragePrice: 0.95,
    TotalVolume: 35064506.04,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-02-28',
    AveragePrice: 0.91,
    TotalVolume: 36801817.68,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-02-21',
    AveragePrice: 0.94,
    TotalVolume: 32804733.22,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-02-14',
    AveragePrice: 0.88,
    TotalVolume: 36476441.86,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-02-07',
    AveragePrice: 0.76,
    TotalVolume: 52288697.89,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-01-31',
    AveragePrice: 0.93,
    TotalVolume: 34721249.92,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-01-24',
    AveragePrice: 0.95,
    TotalVolume: 32787079.21,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-01-17',
    AveragePrice: 0.94,
    TotalVolume: 34426341.87,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-01-10',
    AveragePrice: 0.93,
    TotalVolume: 35264336.01,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-01-03',
    AveragePrice: 0.86,
    TotalVolume: 38142088.04,
    type: 'conventional',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2017-12-31',
    AveragePrice: 0.98,
    TotalVolume: 38267341.61,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-12-24',
    AveragePrice: 1.18,
    TotalVolume: 29102349.33,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-12-17',
    AveragePrice: 1.07,
    TotalVolume: 30757767.03,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-12-10',
    AveragePrice: 1.03,
    TotalVolume: 35634913.01,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-12-03',
    AveragePrice: 1.09,
    TotalVolume: 33824253,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-11-26',
    AveragePrice: 1.24,
    TotalVolume: 24686675,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-11-19',
    AveragePrice: 1.17,
    TotalVolume: 29253484,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-11-12',
    AveragePrice: 1.15,
    TotalVolume: 32336225,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-11-05',
    AveragePrice: 1.19,
    TotalVolume: 32051594.24,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-10-29',
    AveragePrice: 1.29,
    TotalVolume: 30237911.23,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-10-22',
    AveragePrice: 1.44,
    TotalVolume: 26706971.51,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-10-15',
    AveragePrice: 1.58,
    TotalVolume: 25031589.09,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-10-08',
    AveragePrice: 1.65,
    TotalVolume: 24397166.19,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-10-01',
    AveragePrice: 1.64,
    TotalVolume: 24610645.21,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-09-24',
    AveragePrice: 1.62,
    TotalVolume: 24637148.38,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-09-17',
    AveragePrice: 1.57,
    TotalVolume: 25394902.82,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-09-10',
    AveragePrice: 1.56,
    TotalVolume: 26385081.36,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-09-03',
    AveragePrice: 1.57,
    TotalVolume: 26808410.65,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-08-27',
    AveragePrice: 1.47,
    TotalVolume: 28785279.75,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-08-20',
    AveragePrice: 1.41,
    TotalVolume: 29913744.37,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-08-13',
    AveragePrice: 1.33,
    TotalVolume: 32817254.13,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-08-06',
    AveragePrice: 1.33,
    TotalVolume: 32529920.23,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-07-30',
    AveragePrice: 1.32,
    TotalVolume: 31756097.22,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-07-23',
    AveragePrice: 1.31,
    TotalVolume: 32608301.51,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-07-16',
    AveragePrice: 1.33,
    TotalVolume: 32455047.11,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-07-09',
    AveragePrice: 1.17,
    TotalVolume: 39367336.18,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-07-02',
    AveragePrice: 1.21,
    TotalVolume: 38010426.16,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-06-25',
    AveragePrice: 1.17,
    TotalVolume: 37305307.68,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-06-18',
    AveragePrice: 1.18,
    TotalVolume: 38247669.33,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-06-11',
    AveragePrice: 1.21,
    TotalVolume: 37039853.8,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-06-04',
    AveragePrice: 1.24,
    TotalVolume: 37352360.59,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-05-28',
    AveragePrice: 1.28,
    TotalVolume: 37030893.73,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-05-21',
    AveragePrice: 1.26,
    TotalVolume: 34397651.15,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-05-14',
    AveragePrice: 1.19,
    TotalVolume: 36634269.03,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-05-07',
    AveragePrice: 1.09,
    TotalVolume: 47293921.6,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-04-30',
    AveragePrice: 1.18,
    TotalVolume: 38315500.43,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-04-23',
    AveragePrice: 1.18,
    TotalVolume: 35729013.92,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-04-16',
    AveragePrice: 1.23,
    TotalVolume: 35182320.78,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-04-09',
    AveragePrice: 1.21,
    TotalVolume: 34785712.55,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-04-02',
    AveragePrice: 1.21,
    TotalVolume: 34468017.36,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-03-26',
    AveragePrice: 1.24,
    TotalVolume: 32555119.32,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-03-19',
    AveragePrice: 1.25,
    TotalVolume: 31595125.23,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-03-12',
    AveragePrice: 1.22,
    TotalVolume: 32020573.94,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-03-05',
    AveragePrice: 1.13,
    TotalVolume: 33684175.01,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-02-26',
    AveragePrice: 0.99,
    TotalVolume: 37007797.69,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-02-19',
    AveragePrice: 0.99,
    TotalVolume: 33905854.58,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-02-12',
    AveragePrice: 0.87,
    TotalVolume: 41077470.65,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-02-05',
    AveragePrice: 0.77,
    TotalVolume: 61034457.1,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-01-29',
    AveragePrice: 0.96,
    TotalVolume: 39373579.25,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-01-22',
    AveragePrice: 0.94,
    TotalVolume: 42140393.39,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-01-15',
    AveragePrice: 0.98,
    TotalVolume: 38295488.31,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-01-08',
    AveragePrice: 0.99,
    TotalVolume: 38049802.62,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-01-01',
    AveragePrice: 0.89,
    TotalVolume: 38879716.85,
    type: 'conventional',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2018-03-25',
    AveragePrice: 1.03,
    TotalVolume: 43409835.75,
    type: 'conventional',
    year: 2018,
    region: 'TotalUS'
  },
  {
    Date: '2018-03-18',
    AveragePrice: 1.05,
    TotalVolume: 41386314.12,
    type: 'conventional',
    year: 2018,
    region: 'TotalUS'
  },
  {
    Date: '2018-03-11',
    AveragePrice: 1.09,
    TotalVolume: 40449603.12,
    type: 'conventional',
    year: 2018,
    region: 'TotalUS'
  },
  {
    Date: '2018-03-04',
    AveragePrice: 1.07,
    TotalVolume: 40741214.05,
    type: 'conventional',
    year: 2018,
    region: 'TotalUS'
  },
  {
    Date: '2018-02-25',
    AveragePrice: 1.06,
    TotalVolume: 40021528.76,
    type: 'conventional',
    year: 2018,
    region: 'TotalUS'
  },
  {
    Date: '2018-02-18',
    AveragePrice: 1.08,
    TotalVolume: 36709887.49,
    type: 'conventional',
    year: 2018,
    region: 'TotalUS'
  },
  {
    Date: '2018-02-11',
    AveragePrice: 0.97,
    TotalVolume: 43167806.09,
    type: 'conventional',
    year: 2018,
    region: 'TotalUS'
  },
  {
    Date: '2018-02-04',
    AveragePrice: 0.87,
    TotalVolume: 62505646.52,
    type: 'conventional',
    year: 2018,
    region: 'TotalUS'
  },
  {
    Date: '2018-01-28',
    AveragePrice: 1.09,
    TotalVolume: 40171640.84,
    type: 'conventional',
    year: 2018,
    region: 'TotalUS'
  },
  {
    Date: '2018-01-21',
    AveragePrice: 1.08,
    TotalVolume: 42939821.55,
    type: 'conventional',
    year: 2018,
    region: 'TotalUS'
  },
  {
    Date: '2018-01-14',
    AveragePrice: 1.2,
    TotalVolume: 37299945.22,
    type: 'conventional',
    year: 2018,
    region: 'TotalUS'
  },
  {
    Date: '2018-01-07',
    AveragePrice: 1.13,
    TotalVolume: 36703156.72,
    type: 'conventional',
    year: 2018,
    region: 'TotalUS'
  },
  {
    Date: '2015-12-27',
    AveragePrice: 1.52,
    TotalVolume: 549787.59,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-12-20',
    AveragePrice: 1.53,
    TotalVolume: 531478.24,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-12-13',
    AveragePrice: 1.43,
    TotalVolume: 624300.31,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-12-06',
    AveragePrice: 1.52,
    TotalVolume: 514112.96,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-11-29',
    AveragePrice: 1.5,
    TotalVolume: 507830.81,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-11-22',
    AveragePrice: 1.49,
    TotalVolume: 584276.79,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-11-15',
    AveragePrice: 1.6,
    TotalVolume: 511347.26,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-11-08',
    AveragePrice: 1.54,
    TotalVolume: 605197.12,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-11-01',
    AveragePrice: 1.47,
    TotalVolume: 647789.17,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-10-25',
    AveragePrice: 1.62,
    TotalVolume: 560830.54,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-10-18',
    AveragePrice: 1.71,
    TotalVolume: 518034.86,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-10-11',
    AveragePrice: 1.69,
    TotalVolume: 519892.67,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-10-04',
    AveragePrice: 1.72,
    TotalVolume: 557392.73,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-09-27',
    AveragePrice: 1.75,
    TotalVolume: 501814.87,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-09-20',
    AveragePrice: 1.77,
    TotalVolume: 515240.82,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-09-13',
    AveragePrice: 1.8,
    TotalVolume: 552059.64,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-09-06',
    AveragePrice: 1.78,
    TotalVolume: 593797.17,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-08-30',
    AveragePrice: 1.66,
    TotalVolume: 670005.94,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-08-23',
    AveragePrice: 1.72,
    TotalVolume: 666276.26,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-08-16',
    AveragePrice: 1.75,
    TotalVolume: 644689.71,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-08-09',
    AveragePrice: 1,
    TotalVolume: 625259,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-08-02',
    AveragePrice: 1,
    TotalVolume: 573873,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-07-26',
    AveragePrice: 1,
    TotalVolume: 580826,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-07-19',
    AveragePrice: 1,
    TotalVolume: 650389,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-07-12',
    AveragePrice: 1,
    TotalVolume: 608845,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-07-05',
    AveragePrice: 1,
    TotalVolume: 668233,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-06-28',
    AveragePrice: 1.64,
    TotalVolume: 659947.03,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-06-21',
    AveragePrice: 1.66,
    TotalVolume: 638192.89,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-06-14',
    AveragePrice: 1.68,
    TotalVolume: 646098.42,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-06-07',
    AveragePrice: 1.67,
    TotalVolume: 640448.59,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-05-31',
    AveragePrice: 1.58,
    TotalVolume: 716942.71,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-05-24',
    AveragePrice: 1.59,
    TotalVolume: 714266.31,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-05-17',
    AveragePrice: 1.5,
    TotalVolume: 761972.65,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-05-10',
    AveragePrice: 1.42,
    TotalVolume: 861671.11,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-05-03',
    AveragePrice: 1.37,
    TotalVolume: 912681.57,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-04-26',
    AveragePrice: 1.45,
    TotalVolume: 872239.07,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-04-19',
    AveragePrice: 1.59,
    TotalVolume: 675907.97,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-04-12',
    AveragePrice: 1.53,
    TotalVolume: 810018.27,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-04-05',
    AveragePrice: 1.63,
    TotalVolume: 661842.02,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-03-29',
    AveragePrice: 1.6,
    TotalVolume: 674551.02,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-03-22',
    AveragePrice: 1.49,
    TotalVolume: 682640.03,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-03-15',
    AveragePrice: 1.5,
    TotalVolume: 644584.67,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-03-08',
    AveragePrice: 1.49,
    TotalVolume: 783913.05,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-03-01',
    AveragePrice: 1.4,
    TotalVolume: 814484.79,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-02-22',
    AveragePrice: 1.51,
    TotalVolume: 673446.69,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-02-15',
    AveragePrice: 1.58,
    TotalVolume: 616177,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-02-08',
    AveragePrice: 1.48,
    TotalVolume: 730874.31,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-02-01',
    AveragePrice: 1.36,
    TotalVolume: 740896.97,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-01-25',
    AveragePrice: 1.53,
    TotalVolume: 556368.86,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-01-18',
    AveragePrice: 1.42,
    TotalVolume: 713120,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-01-11',
    AveragePrice: 1.42,
    TotalVolume: 669528.88,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2015-01-04',
    AveragePrice: 1.46,
    TotalVolume: 612910.15,
    type: 'organic',
    year: 2015,
    region: 'TotalUS'
  },
  {
    Date: '2016-12-25',
    AveragePrice: 1.34,
    TotalVolume: 914035.42,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-12-18',
    AveragePrice: 1.43,
    TotalVolume: 797042.27,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-12-11',
    AveragePrice: 1.42,
    TotalVolume: 856795.63,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-12-04',
    AveragePrice: 1.56,
    TotalVolume: 832767.55,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-11-27',
    AveragePrice: 1.64,
    TotalVolume: 761675.87,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-11-20',
    AveragePrice: 1.63,
    TotalVolume: 860320.59,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-11-13',
    AveragePrice: 1.7,
    TotalVolume: 863948.15,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-11-06',
    AveragePrice: 1.68,
    TotalVolume: 897671.29,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-10-30',
    AveragePrice: 1.93,
    TotalVolume: 647723.55,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-10-23',
    AveragePrice: 1.63,
    TotalVolume: 699763.35,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-10-16',
    AveragePrice: 1.5,
    TotalVolume: 815859.49,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-10-09',
    AveragePrice: 1.52,
    TotalVolume: 878367.41,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-10-02',
    AveragePrice: 1.71,
    TotalVolume: 790926.03,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-09-25',
    AveragePrice: 1.69,
    TotalVolume: 808891.94,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-09-18',
    AveragePrice: 1.67,
    TotalVolume: 871627.58,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-09-11',
    AveragePrice: 1.52,
    TotalVolume: 1103488.85,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-09-04',
    AveragePrice: 1.54,
    TotalVolume: 1052088.77,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-08-28',
    AveragePrice: 1.49,
    TotalVolume: 948530.88,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-08-21',
    AveragePrice: 1.51,
    TotalVolume: 1033169.7,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-08-14',
    AveragePrice: 1.48,
    TotalVolume: 1093287.79,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-08-07',
    AveragePrice: 1.55,
    TotalVolume: 1012237.01,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-07-31',
    AveragePrice: 1.58,
    TotalVolume: 946087.81,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-07-24',
    AveragePrice: 1.65,
    TotalVolume: 919489.84,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-07-17',
    AveragePrice: 1.63,
    TotalVolume: 1018118.27,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-07-10',
    AveragePrice: 1.51,
    TotalVolume: 1043428.53,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-07-03',
    AveragePrice: 1.47,
    TotalVolume: 1073595.37,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-06-26',
    AveragePrice: 1.5,
    TotalVolume: 1007378.78,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-06-19',
    AveragePrice: 1.45,
    TotalVolume: 1071066.66,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-06-12',
    AveragePrice: 1.45,
    TotalVolume: 975275.55,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-06-05',
    AveragePrice: 1.43,
    TotalVolume: 1012717.93,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-05-29',
    AveragePrice: 1.41,
    TotalVolume: 1085152.56,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-05-22',
    AveragePrice: 1.36,
    TotalVolume: 1165715.01,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-05-15',
    AveragePrice: 1.45,
    TotalVolume: 1023252.17,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-05-08',
    AveragePrice: 1.3,
    TotalVolume: 1137940.78,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-05-01',
    AveragePrice: 1.28,
    TotalVolume: 1317867,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-04-24',
    AveragePrice: 1.25,
    TotalVolume: 1475457.53,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-04-17',
    AveragePrice: 1.38,
    TotalVolume: 1022217.32,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-04-10',
    AveragePrice: 1.26,
    TotalVolume: 1179603.03,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-04-03',
    AveragePrice: 1.44,
    TotalVolume: 930722.39,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-03-27',
    AveragePrice: 1.44,
    TotalVolume: 900644.79,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-03-20',
    AveragePrice: 1.27,
    TotalVolume: 1045450.41,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-03-13',
    AveragePrice: 1.29,
    TotalVolume: 1023655.87,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-03-06',
    AveragePrice: 1.28,
    TotalVolume: 1012415.85,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-02-28',
    AveragePrice: 1.44,
    TotalVolume: 845011.63,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-02-21',
    AveragePrice: 1.45,
    TotalVolume: 738856.92,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-02-14',
    AveragePrice: 1.37,
    TotalVolume: 852463.31,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-02-07',
    AveragePrice: 1.44,
    TotalVolume: 758795.1,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-01-31',
    AveragePrice: 1.43,
    TotalVolume: 772077.2,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-01-24',
    AveragePrice: 1.41,
    TotalVolume: 776964.55,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-01-17',
    AveragePrice: 1.44,
    TotalVolume: 695341.42,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-01-10',
    AveragePrice: 1.35,
    TotalVolume: 828670.59,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2016-01-03',
    AveragePrice: 1.43,
    TotalVolume: 704100.5,
    type: 'organic',
    year: 2016,
    region: 'TotalUS'
  },
  {
    Date: '2017-12-31',
    AveragePrice: 1.52,
    TotalVolume: 1243940.09,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-12-24',
    AveragePrice: 1.64,
    TotalVolume: 1179930.12,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-12-17',
    AveragePrice: 1.57,
    TotalVolume: 1148617.16,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-12-10',
    AveragePrice: 1.54,
    TotalVolume: 1217680.36,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-12-03',
    AveragePrice: 1.62,
    TotalVolume: 1119325,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-11-26',
    AveragePrice: 1.72,
    TotalVolume: 957800.72,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-11-19',
    AveragePrice: 1.77,
    TotalVolume: 967886.13,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-11-12',
    AveragePrice: 1.81,
    TotalVolume: 1044591.43,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-11-05',
    AveragePrice: 1.82,
    TotalVolume: 1068530.09,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-10-29',
    AveragePrice: 1.84,
    TotalVolume: 1123703.61,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-10-22',
    AveragePrice: 1.82,
    TotalVolume: 1180823.79,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-10-15',
    AveragePrice: 1.85,
    TotalVolume: 1172057.19,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-10-08',
    AveragePrice: 1.9,
    TotalVolume: 1164140.49,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-10-01',
    AveragePrice: 1.95,
    TotalVolume: 1072521.35,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-09-24',
    AveragePrice: 1.94,
    TotalVolume: 1125443.38,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-09-17',
    AveragePrice: 2,
    TotalVolume: 1074567.7,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-09-10',
    AveragePrice: 2.03,
    TotalVolume: 1093955.66,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-09-03',
    AveragePrice: 2.06,
    TotalVolume: 1075538.53,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-08-27',
    AveragePrice: 2.09,
    TotalVolume: 1045992.02,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-08-20',
    AveragePrice: 1.96,
    TotalVolume: 1071538.25,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-08-13',
    AveragePrice: 1.88,
    TotalVolume: 1014709.07,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-08-06',
    AveragePrice: 1.83,
    TotalVolume: 1059971.14,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-07-30',
    AveragePrice: 1.78,
    TotalVolume: 1091590.78,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-07-23',
    AveragePrice: 1.76,
    TotalVolume: 1214158.19,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-07-16',
    AveragePrice: 1.78,
    TotalVolume: 1148354.84,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-07-09',
    AveragePrice: 1.71,
    TotalVolume: 1130374.7,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-07-02',
    AveragePrice: 1.74,
    TotalVolume: 1173393.06,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-06-25',
    AveragePrice: 1.77,
    TotalVolume: 1101009.92,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-06-18',
    AveragePrice: 1.71,
    TotalVolume: 1304554.29,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-06-11',
    AveragePrice: 1.56,
    TotalVolume: 1397448.17,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-06-04',
    AveragePrice: 1.64,
    TotalVolume: 1352960.47,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-05-28',
    AveragePrice: 1.69,
    TotalVolume: 1302205.55,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-05-21',
    AveragePrice: 1.71,
    TotalVolume: 1210560.61,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-05-14',
    AveragePrice: 1.55,
    TotalVolume: 1375125.12,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-05-07',
    AveragePrice: 1.57,
    TotalVolume: 1394126.23,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-04-30',
    AveragePrice: 1.68,
    TotalVolume: 1248175.29,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-04-23',
    AveragePrice: 1.61,
    TotalVolume: 1190461.18,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-04-16',
    AveragePrice: 1.49,
    TotalVolume: 1493331.28,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-04-09',
    AveragePrice: 1.43,
    TotalVolume: 1387436.32,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-04-02',
    AveragePrice: 1.42,
    TotalVolume: 1492167.41,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-03-26',
    AveragePrice: 1.29,
    TotalVolume: 1581127.36,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-03-19',
    AveragePrice: 1.5,
    TotalVolume: 1284018.65,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-03-12',
    AveragePrice: 1.38,
    TotalVolume: 1337596.89,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-03-05',
    AveragePrice: 1.16,
    TotalVolume: 1619398.24,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-02-26',
    AveragePrice: 1.21,
    TotalVolume: 1436663.15,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-02-19',
    AveragePrice: 1.31,
    TotalVolume: 1634877.11,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-02-12',
    AveragePrice: 1.41,
    TotalVolume: 1060775.98,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-02-05',
    AveragePrice: 1.36,
    TotalVolume: 1015621.03,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-01-29',
    AveragePrice: 1.43,
    TotalVolume: 953206.1,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-01-22',
    AveragePrice: 1.37,
    TotalVolume: 994282.98,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-01-15',
    AveragePrice: 1.44,
    TotalVolume: 975724.28,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-01-08',
    AveragePrice: 1.43,
    TotalVolume: 990721.83,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2017-01-01',
    AveragePrice: 1.48,
    TotalVolume: 808971.88,
    type: 'organic',
    year: 2017,
    region: 'TotalUS'
  },
  {
    Date: '2018-03-25',
    AveragePrice: 1.55,
    TotalVolume: 1559967.2,
    type: 'organic',
    year: 2018,
    region: 'TotalUS'
  },
  {
    Date: '2018-03-18',
    AveragePrice: 1.54,
    TotalVolume: 1675804.22,
    type: 'organic',
    year: 2018,
    region: 'TotalUS'
  },
  {
    Date: '2018-03-11',
    AveragePrice: 1.52,
    TotalVolume: 1664234.88,
    type: 'organic',
    year: 2018,
    region: 'TotalUS'
  },
  {
    Date: '2018-03-04',
    AveragePrice: 1.52,
    TotalVolume: 1634430.77,
    type: 'organic',
    year: 2018,
    region: 'TotalUS'
  },
  {
    Date: '2018-02-25',
    AveragePrice: 1.57,
    TotalVolume: 1459852.55,
    type: 'organic',
    year: 2018,
    region: 'TotalUS'
  },
  {
    Date: '2018-02-18',
    AveragePrice: 1.52,
    TotalVolume: 1814929.97,
    type: 'organic',
    year: 2018,
    region: 'TotalUS'
  },
  {
    Date: '2018-02-11',
    AveragePrice: 1.56,
    TotalVolume: 1317000.47,
    type: 'organic',
    year: 2018,
    region: 'TotalUS'
  },
  {
    Date: '2018-02-04',
    AveragePrice: 1.53,
    TotalVolume: 1384683.41,
    type: 'organic',
    year: 2018,
    region: 'TotalUS'
  },
  {
    Date: '2018-01-28',
    AveragePrice: 1.61,
    TotalVolume: 1336979.09,
    type: 'organic',
    year: 2018,
    region: 'TotalUS'
  },
  {
    Date: '2018-01-21',
    AveragePrice: 1.63,
    TotalVolume: 1283987.65,
    type: 'organic',
    year: 2018,
    region: 'TotalUS'
  },
  {
    Date: '2018-01-14',
    AveragePrice: 1.59,
    TotalVolume: 1476651.08,
    type: 'organic',
    year: 2018,
    region: 'TotalUS'
  },
  {
    Date: '2018-01-07',
    AveragePrice: 1.51,
    TotalVolume: 1517332.7,
    type: 'organic',
    year: 2018,
    region: 'TotalUS'
  }
]
export default avocadoData


// WEBPACK FOOTER //
// ./src/datasets/avocado-totalus.js